module.exports = __webpack_public_path__ + "assets/img/iso.c5b933fa.svg";